(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[469],{

/***/ 7469:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lets-make/[activitySlug]",
      function () {
        return __webpack_require__(1599);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_layout_Background__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7940);
/* harmony import */ var _components_AppChrome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7504);
/* harmony import */ var _components_Hero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8634);
/* harmony import */ var _components_activities_Activity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3194);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8716);






function ActivityPage(param) {
    var activity = param.entry, letsMakePage = param.letsMakePage;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_AppChrome__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: "/lets-make/".concat(activity.slug),
                title: "".concat(letsMakePage.title, ": ").concat(activity.title).concat(activity.subHeading && ", ".concat(activity.subHeading)),
                image: (ref = activity.activityImage) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout_Background__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                $color: "grey9",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Hero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: activity.title,
                        subheading: activity.activityType.map(function(activityType) {
                            return activityType.title;
                        }).join(" / ")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_activities_Activity__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        activity: activity
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ActivityPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [184,182,121,194,774,888,179], function() { return __webpack_exec__(7469); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);